import { useState } from 'react'
import { AnimatePresence, motion} from 'framer-motion'


// css
import './css/slidecomponent.css'
import './css/slide4.css'

//images
import User1 from '../images/static/user1.jpg'
import User2 from '../images/static/user2.jpg'
import User3 from '../images/static/user3.jpg'

const Slide_4 = ({ counter }) => { 

	const [review, setReview] = useState({counter: 0})
	const updateReviewsCounter = x => {
		setReview(prev => ({...prev, counter: x}))
	}

	return(
		<AnimatePresence>
			{counter === 4 &&
			<motion.div 
				key="slide_components_1key0"
				initial={{opacity:0}}
				animate={{opacity:1}}
				transition={{duration:1}}
				exit={{opacity:0}}
				className="slide_components" id="slide_components_4" 
				>
				<div className="reviews_body">
					<div className="animated_railway_reviews">
						<AnimatePresence>
							{
								review.counter === 0 && <motion.div initial={{opacity:0}} animate={{opacity:1}} transition={{duration:1}} exit={{opacity:0}} key="001">
									<i class="fas fa-quote-right"></i>
									<section>
										Keep it up bro Good job
									</section>
									<img src={User1} alt="" />
									<b>Oussama Ouss</b>
									<p>Software developer</p>
								</motion.div>
							}
						</AnimatePresence>


						<AnimatePresence>
							{
								review.counter === 1 && <motion.div initial={{opacity:0}} animate={{opacity:1}} transition={{duration:1}} exit={{opacity:0}} key="002">
									<i class="fas fa-quote-right"></i>
									<section>
										Keep up the good work!
									</section>
									<img src={User2} alt="" />
									<b>Amina La Gata</b>
									<p>Frontend web developer</p>
								</motion.div>
							}
						</AnimatePresence>

						<AnimatePresence>
							{
								review.counter === 2 && <motion.div initial={{opacity:0}} animate={{opacity:1}} transition={{duration:1}} exit={{opacity:0}} key="003">
									<i class="fas fa-quote-right"></i>
									<section>
										Great job bro
									</section>
									<img src={User3} alt="" />
									<b>Habib Mebdoua</b>
									<p>web developer</p>
								</motion.div>
							}
						</AnimatePresence>
					</div>
					<div className="reviews_caroucel_buttons_container">
						<button className={review.counter === 0 ? "caroucel_button active_caroucel" : "caroucel_button"} onClick={() => updateReviewsCounter(0)}></button>
						<button className={review.counter === 1 ? "caroucel_button active_caroucel" : "caroucel_button"} onClick={() => updateReviewsCounter(1)}></button>
						<button className={review.counter === 2 ? "caroucel_button active_caroucel" : "caroucel_button"} onClick={() => updateReviewsCounter(2)}></button>
					</div>
				</div>
			</motion.div>
			}
		</AnimatePresence>
		)
}

export default Slide_4